<h1 class="card-title table-card-title">Connect Request</h1>
<div *ngIf="isRequestView" class="container font-title">
    <div class="main-body">
          <div class="row gutters-sm row d-flex justify-content-center">
            <div class="col-md-4 mb-4">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex flex-column align-items-center text-center">
                    <div [innerHTML]="safeAvatarSVG" class="profile-image"></div>
                    <!-- <img src="https://bootdey.com/img/Content/avatar/avatar7.png" alt="Admin" class="rounded-circle" width="150"> -->
                    <div class="mt-3">
                      <h4>{{ teacherInfo.name }} wants to connect</h4>
                      <!-- <p class="text-secondary mb-1">{{ teacherInfo.name }} wants to connect</p> -->
                      <!-- <p class="text-muted font-size-sm">Bay Area, San Francisco, CA</p> -->
                      <button class="btn btn-primary mr-1" (click)="acceptedConnectRequest()">{{'viewRequest.text1' | translate}}</button>
                      <button class="btn btn-danger" (click)="rejectedConnectRequest()">{{'viewRequest.text2' | translate}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
    </div>
</div>
<h3 *ngIf="!isRequestView" class="card-title table-card-title">There is no Connect Request Found</h3>